import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Transcription from './pages/Transcription';
import Folders from './pages/Folders';
import Tags from './pages/Tags';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Webhooks from './pages/Webhooks';
import Profile from './pages/Profile';
import PublicShare from './pages/PublicShare';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loader">جاري التحميل...</div>;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
}

export default function App() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/share/:token" element={<PublicShare />} />
      <Route path="/*" element={
        <PrivateRoute roles={['admin', 'supervisor', 'team']}>
          <Layout>
            <Routes>
              <Route path="/" element={<Transcription />} />
              <Route path="/folders" element={<Folders />} />
              <Route path="/tags" element={<Tags />} />
              <Route path="/users" element={<PrivateRoute roles={['admin', 'supervisor']}><Users /></PrivateRoute>} />
              <Route path="/webhooks" element={<PrivateRoute roles={['admin']}><Webhooks /></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute roles={['admin']}><Settings /></PrivateRoute>} />
              <Route path="/profile" element={<Profile />} />
            </Routes>
          </Layout>
        </PrivateRoute>
      } />
    </Routes>
  );
}
